export const MIN_LAYER_THICKNESS = 0.1;
export const DEFAULT_PRE_DRILL_THICKNESS = 0.5;
export const DEFAULT_PROPOSED_LAYER_THICKNESS = 1;
export const PROPOSED_LAYER_SOIL_ID = 0;
export const CUSTOM_SOIL_LIBRARY_ID = 5;
